import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function OnAir({children}: CommonSectionProps) {
  const {ref, inView, entry} = useInView();
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_provider: 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);
  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        viewimp_contents: {
          imp_id: 'sonair',
          layer1: '온에어',
        },
        click: {
          imp_id: 'sonair',
          layer1: '온에어',
        },
        customProps: {
          section_type: '온에어',
        },
      })}
    >
      <div>{children}</div>
    </div>
  );
}
